import React from 'react';

interface CheckCircleIconProps {
  readonly className?: string;
  readonly size?: number;
}

export const CheckCircleIcon = ({ className, size = 20 }: CheckCircleIconProps) => (
  <svg className={className} width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path
      d="M8 0C3.58 0 0 3.58 0 8C0 12.416 3.58 16 8 16C12.416 16 16 12.416 16 8C16 3.58 12.416 0 8 0ZM6.4 12L2.4 8L3.532 6.868L6.4 9.736L12.468 3.668L13.6 4.8L6.4 12Z"
      fill="currentColor"
    />
  </svg>
);

export const ChevronIcon = () => (
  <svg className={'icon'} width="10" height="7" viewBox="0 0 10 7" fill="none">
    <path d="M1 1.5L5 5.5L9 1.5" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const ProtectionIcon = () => (
  <svg className={'icon'} width="17" height="16" viewBox="0 0 17 16" fill="none">
    <g>
      <path
        d="M8.25 16C8.17845 16 8.10695 15.9846 8.04055 15.9541L6.543 15.263C3.32765 13.7788 1.25 10.5318 1.25 6.99052V2.00003C1.25 1.74588 1.44065 1.53202 1.69335 1.50318C2.6809 1.39038 3.67335 1.22508 4.64255 1.01173C5.8047 0.755875 6.96215 0.425075 8.08325 0.028575C8.19115 -0.009525 8.30885 -0.009525 8.41675 0.028575C9.53785 0.425075 10.6953 0.755875 11.8574 1.01173C12.8267 1.22513 13.8191 1.39038 14.8066 1.50318C15.0593 1.53198 15.25 1.74588 15.25 2.00003V6.99052C15.25 10.5318 13.1723 13.7789 9.957 15.263L8.45945 15.9541C8.39305 15.9846 8.3215 16 8.25 16ZM2.25 2.44288V6.99052C2.25 10.1431 4.0996 13.0337 6.9619 14.3548L8.25 14.9493L9.5381 14.3548C12.4004 13.0337 14.25 10.1431 14.25 6.99052V2.44288C13.3753 2.32958 12.5003 2.17703 11.6426 1.98828C10.4981 1.73633 9.35745 1.41408 8.25 1.02978C7.1426 1.41408 6.00195 1.73633 4.8574 1.98828C3.99975 2.17698 3.12475 2.32958 2.25 2.44288Z"
        fill="#F2994A"
      />
      <path
        d="M10.25 11.5H6.25C5.6985 11.5 5.25 11.0515 5.25 10.5V7C5.25 6.4485 5.6985 6 6.25 6H10.25C10.8015 6 11.25 6.4485 11.25 7V10.5C11.25 11.0515 10.8015 11.5 10.25 11.5ZM6.25 7V10.5H10.2507L10.25 7H6.25Z"
        fill="#F2994A"
      />
      <path
        d="M9.75 7H6.75C6.4739 7 6.25 6.7761 6.25 6.5V5.5C6.25 4.3972 7.1472 3.5 8.25 3.5C9.3528 3.5 10.25 4.3972 10.25 5.5V6.5C10.25 6.7761 10.0261 7 9.75 7ZM7.25 6H9.25V5.5C9.25 4.9485 8.8015 4.5 8.25 4.5C7.6985 4.5 7.25 4.9485 7.25 5.5V6Z"
        fill="#F2994A"
      />
    </g>
  </svg>
);

export const PasswordIcon = () => (
  <svg className={'icon'} width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      d="M12.3824 5.76957H12.1218V3.8693C12.1219 1.73577 10.386 0 8.2522 0C6.11851 0 4.38259 1.73577 4.38259 3.8693V5.76957H4.12182C3.36167 5.76957 2.74316 6.38807 2.74316 7.14823V14.6213C2.74316 15.3814 3.36167 15.9999 4.12182 15.9999H12.3824C13.1426 15.9999 13.7611 15.3814 13.7611 14.6213V7.14823C13.7611 6.38807 13.1427 5.76957 12.3824 5.76957ZM5.56429 3.8693C5.56429 2.38736 6.77011 1.18171 8.2522 1.18171C9.7343 1.18171 10.9401 2.38736 10.9401 3.8693V5.76957H5.56429V3.8693ZM12.5794 14.6213C12.5794 14.7281 12.4892 14.8183 12.3824 14.8183H4.12182C4.01507 14.8183 3.92487 14.7281 3.92487 14.6213V7.14823C3.92487 7.04148 4.01507 6.95127 4.12182 6.95127H4.97344H11.531H12.3824C12.4892 6.95127 12.5794 7.04148 12.5794 7.14823V14.6213Z"
      fill="#F2994A"
    />
    <path
      d="M8.25101 9.16284C7.9247 9.16284 7.66016 9.42731 7.66016 9.7537V12.0159C7.66016 12.3423 7.9247 12.6067 8.25101 12.6067C8.57732 12.6067 8.84186 12.3423 8.84186 12.0159V9.7537C8.84186 9.42731 8.57732 9.16284 8.25101 9.16284Z"
      fill="#F2994A"
    />
  </svg>
);

export const StarIcon = () => (
  <svg className={'icon'} width="17" height="17" viewBox="0 0 17 17" fill="none">
    <path
      d="M6.54285 4.28363C7.30724 1.82073 7.68943 0.589287 8.37817 0.507234C8.45913 0.497589 8.54087 0.497589 8.62183 0.507234C9.31057 0.589287 9.69276 1.82073 10.4571 4.28363C10.6691 4.96661 10.7751 5.3081 11.0203 5.51783C11.0519 5.5448 11.0848 5.56987 11.1191 5.59293C11.3854 5.77228 11.7283 5.77228 12.4143 5.77228C14.8879 5.77228 16.1247 5.77228 16.4121 6.43268C16.4459 6.51031 16.4711 6.5917 16.4874 6.67529C16.6257 7.38641 15.6251 8.14748 13.6239 9.66963C13.0689 10.0917 12.7915 10.3028 12.6767 10.6118C12.662 10.6515 12.6494 10.6921 12.639 10.7333C12.5584 11.0539 12.6643 11.3953 12.8763 12.0783C13.6407 14.5412 14.0229 15.7727 13.5118 16.2629C13.4517 16.3205 13.3855 16.3708 13.3146 16.4128C12.7114 16.7703 11.7108 16.0092 9.70958 14.487C9.15464 14.0649 8.87716 13.8539 8.56101 13.8351C8.52037 13.8327 8.47963 13.8327 8.43899 13.8351C8.12283 13.8539 7.84536 14.0649 7.29041 14.487C5.28923 16.0092 4.28863 16.7703 3.68536 16.4128C3.61445 16.3708 3.54832 16.3205 3.48823 16.2629C2.9771 15.7727 3.35929 14.5412 4.12368 12.0783C4.33565 11.3953 4.44164 11.0539 4.36099 10.7333C4.35063 10.6921 4.33804 10.6515 4.32328 10.6118C4.20854 10.3028 3.93106 10.0917 3.37612 9.66963C1.37493 8.14748 0.374334 7.38641 0.512625 6.67529C0.528881 6.5917 0.554142 6.51031 0.587922 6.43268C0.875295 5.77228 2.1121 5.77228 4.5857 5.77228C5.27165 5.77228 5.61463 5.77228 5.88094 5.59293C5.91517 5.56987 5.94814 5.5448 5.97966 5.51783C6.22489 5.3081 6.33088 4.96661 6.54285 4.28363Z"
      fill="#FBA253"
    />
  </svg>
);

export const TimerIcon = ({ color = 'white' }) => (
  <svg
    className={'icon'}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99414 20C4.47114 20 -0.00585938 15.523 -0.00585938 10C-0.00585938 4.477 4.47114 0 9.99414 0C15.5171 0 19.9941 4.477 19.9941 10C19.9941 15.523 15.5171 20 9.99414 20ZM9.99414 18C12.1159 18 14.1507 17.1571 15.651 15.6569C17.1513 14.1566 17.9941 12.1217 17.9941 10C17.9941 7.87827 17.1513 5.84344 15.651 4.34315C14.1507 2.84285 12.1159 2 9.99414 2C7.87241 2 5.83758 2.84285 4.33729 4.34315C2.837 5.84344 1.99414 7.87827 1.99414 10C1.99414 12.1217 2.837 14.1566 4.33729 15.6569C5.83758 17.1571 7.87241 18 9.99414 18ZM10.9941 10H14.9941V12H8.99414V5H10.9941V10Z"
      fill={color}
    />
  </svg>
);

export const WhiteCheckIcon = ({ color = 'white' }) => {
  return (
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none">
      <path
        d="M3.52552 8.5C3.72506 8.5 3.88283 8.41106 3.9942 8.23786L8.37935 1.27238C8.46288 1.13663 8.5 1.03365 8.5 0.92598C8.5 0.66852 8.32831 0.5 8.07309 0.5C7.89211 0.5 7.78538 0.560854 7.67401 0.738736L3.50696 7.43739L1.34455 4.58192C1.22854 4.41808 1.11717 4.35255 0.945476 4.35255C0.685615 4.35255 0.5 4.53511 0.5 4.79257C0.5 4.90023 0.546404 5.02194 0.634571 5.13429L3.04292 8.2285C3.18677 8.41106 3.32599 8.5 3.52552 8.5Z"
        fill={color}
        stroke={color}
        strokeWidth="0.666667"
      />
    </svg>
  );
};

export const FeatureIcon = () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.375 1.75H16.625C18.0748 1.75 19.25 2.92526 19.25 4.375V16.625C19.25 18.0748 18.0748 19.25 16.625 19.25H4.375C2.92526 19.25 1.75 18.0748 1.75 16.625V4.375C1.75 2.92526 2.92526 1.75 4.375 1.75ZM8.96875 14.5512L15.4962 7.60375C15.7924 7.26041 15.7772 6.7477 15.4613 6.4225C15.2969 6.25685 15.0733 6.16367 14.84 6.16367C14.6067 6.16367 14.3831 6.25685 14.2188 6.4225L8.33 12.6875L6.79 11.0513C6.58267 10.7976 6.25099 10.681 5.93053 10.7491C5.61007 10.8173 5.35452 11.0587 5.26832 11.3748C5.18213 11.6909 5.27974 12.0286 5.52125 12.25L7.69125 14.5512C7.85768 14.7258 8.0888 14.824 8.33 14.8225C8.5712 14.824 8.80232 14.7258 8.96875 14.5512Z"
      fill="#4BAE76"
    />
  </svg>
);

export const ConsentIcon = () => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" className={'icon'}>
      <g clipPath="url(#clip0_38_87064)">
        <path
          d="M8.16504 16C8.09349 16 8.02199 15.9846 7.95559 15.9541L6.45804 15.263C3.24269 13.7788 1.16504 10.5318 1.16504 6.99052V2.00003C1.16504 1.74588 1.35569 1.53202 1.60839 1.50318C2.59594 1.39038 3.58839 1.22508 4.55759 1.01173C5.71974 0.755875 6.87719 0.425075 7.99829 0.028575C8.10619 -0.009525 8.22389 -0.009525 8.33179 0.028575C9.45289 0.425075 10.6103 0.755875 11.7724 1.01173C12.7417 1.22513 13.7341 1.39038 14.7216 1.50318C14.9743 1.53198 15.165 1.74588 15.165 2.00003V6.99052C15.165 10.5318 13.0873 13.7789 9.87204 15.263L8.37449 15.9541C8.30809 15.9846 8.23654 16 8.16504 16ZM2.16504 2.44288V6.99052C2.16504 10.1431 4.01464 13.0337 6.87694 14.3548L8.16504 14.9493L9.45314 14.3548C12.3154 13.0337 14.165 10.1431 14.165 6.99052V2.44288C13.2903 2.32958 12.4153 2.17703 11.5576 1.98828C10.4131 1.73633 9.27249 1.41408 8.16504 1.02978C7.05764 1.41408 5.91699 1.73633 4.77244 1.98828C3.91479 2.17698 3.03979 2.32958 2.16504 2.44288Z"
          fill="#FBA253"
        />
        <path
          d="M8.16505 12C8.12417 12 8.08331 11.9923 8.04537 11.977L7.18962 11.6315C5.35227 10.8894 4.16504 9.26588 4.16504 7.49526V5.00001C4.16504 4.87294 4.27398 4.76601 4.41838 4.75159C4.9827 4.69519 5.54982 4.61254 6.10365 4.50586C6.76773 4.37794 7.42914 4.21254 8.06977 4.01429C8.13142 3.99524 8.19868 3.99524 8.26034 4.01429C8.90097 4.21254 9.56237 4.37794 10.2264 4.50586C10.7803 4.61256 11.3474 4.69519 11.9117 4.75159C12.0561 4.76599 12.165 4.87294 12.165 5.00001V7.49526C12.165 9.26588 10.9778 10.8894 9.14049 11.6315L8.28474 11.977C8.2468 11.9923 8.20591 12 8.16505 12ZM4.73647 5.22144V7.49526C4.73647 9.07155 5.79339 10.5169 7.42899 11.1774L8.16505 11.4746L8.90111 11.1774C10.5367 10.5169 11.5936 9.07155 11.5936 7.49526V5.22144C11.0938 5.16479 10.5938 5.08851 10.1037 4.99414C9.44966 4.86816 8.79788 4.70704 8.16505 4.51489C7.53225 4.70704 6.88045 4.86816 6.22642 4.99414C5.73633 5.08849 5.23633 5.16479 4.73647 5.22144Z"
          fill="#FBA253"
        />
      </g>
      <defs>
        <clipPath id="clip0_38_87064">
          <rect width="16" height="16" fill="white" transform="translate(0.165039)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CloseIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M1 1L13 13M13 1L1 13" stroke="#8C8C8C" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const WideCheckIcon = ({ color = 'white' }) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.75 9L7.5 12.75L15 5.25"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color}
      />
    </svg>
  );
};

export const CheckFilledIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.1561 9.12653L11.6745 16.3265C11.4489 16.6229 11.0997 16.7981 10.7277 16.8005H10.7193C10.3509 16.8005 10.0029 16.6301 9.77493 16.3397L6.85653 12.6113C6.44853 12.0905 6.53973 11.3357 7.06173 10.9277C7.58253 10.5185 8.33853 10.6097 8.74653 11.1329L10.7061 13.6361L15.2469 7.67333C15.6477 7.14653 16.4001 7.04333 16.9293 7.44533C17.4561 7.84733 17.5581 8.59973 17.1561 9.12653ZM12 0C5.3724 0 0 5.3724 0 12C0 18.6264 5.3724 24 12 24C18.6276 24 24 18.6264 24 12C24 5.3724 18.6276 0 12 0Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F58A3C"
      />
    </svg>
  );
};
